<template>
  <div class="q-container mt-5 get-the-look__container">
    <BackButton/>
    <div class="q-row get-the-look__row q-d-flex q-align-items-stretch" v-if="hasStylisation">
      <MainHeader :title="getStylisationProduct.title"/>
      <div class="q-col-md-6 q-position-relative get-the-look__stylisation-container">
        <ComponentLoader :loading="getStylisationLoading"/>
        <StylizationImage :stylization="getStylisationProduct"/>

      </div>
      <div class="q-col-md-6 q-position-relative get-the-look__gtl-group-container">

        <GetTheLooks :use-as-separate="false"/>
      </div>
    </div>
    <NoStylisationInfo :show-alert="!hasStylisation && !getStylisationLoading"/>
  </div>

</template>

<script setup>
import { onMounted, onUnmounted, } from 'vue'
import { storeToRefs } from 'pinia'
import StylizationImage from '@/components/Stylisation/StylizationImage'
import BackButton from '@/components/BackButton'
import ComponentLoader from './ComponentLoader'
import MainHeader from '@/components/MainHeader'

import { useStylisationStore } from '@/store/stylisationStore'
import GetTheLooks from '@/components/GetTheLooksCategorized'
import NoStylisationInfo from '@/components/NoStylisationInfo'

const stylisationStore = useStylisationStore()

const { hasStylisation, getStylisationProduct, getStylisationLoading } = storeToRefs(stylisationStore)

onMounted(async () => {
  await stylisationStore.fetchStylisation()
  window.addEventListener('hashchange', stylisationStore.updateHash)
})

onUnmounted(() => {
  window.removeEventListener('hashchange', stylisationStore.updateHash)
})

</script>
<style>
.swiper-button-prev.swiper-button-disabled, .swiper-button-next.swiper-button-disabled {
  display: none;
}

.get-the-look__gtl-group-container, .get-the-look__stylisation-container {
  min-height: 300px;
  position: relative !important;
}

.get-the-look__row {
  display: flex;
  align-items: stretch;
}

.get-the-look__stylisation-container,
.get-the-look__gtl-group-container {
  flex: 1; /* Daje obu kontenerom tę samą elastyczność */
}

.swiper-button-prev, .swiper-button-next {
  color: #000 !important;
}

.swiper-pagination-bullet.swiper-pagination-bullet-active {
  color: #000 !important;
  background: #000 !important;
}

.swiper-button-prev:after, .swiper-button-next:after {
  padding: 20px !important;
}

</style>
